export const ar = {
  // Brand
  'brand.name': 'بيفلونت',
  'brand.full_name': 'مركز بيفلونت للغات',
  'brand.alt': 'شعار بيفلونت',

  // Navigation
  'nav.home': 'الرئيسية',
  'nav.courses': 'الدورات',
  'nav.languages': 'اللغات',
  'nav.placement_test': 'اختبار تحديد المستوى',
  'nav.packages': 'الباقات',
  'nav.corporate': 'الشركات',
  'nav.about': 'من نحن',
  'nav.contact': 'اتصل بنا',
  'nav.login': 'تسجيل الدخول',
  'nav.register': 'ابدأ الآن',
  'nav.dashboard': 'لوحة التحكم',
  'nav.logout': 'تسجيل الخروج',

  // Common
  'common.submit': 'إرسال',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ',
  'common.loading': 'جاري التحميل...',
  'common.required': 'مطلوب',
  'common.code': 'الرمز',
  'common.details': 'التفاصيل',
  'common.view_all': 'عرض الكل',
  'common.enrolling_now': 'التسجيل مفتوح',
  'common.join_community': 'انضم إلى مجتمعنا العالمي',
  'common.per_course': 'لكل دورة',
  'common.aed_hr': 'درهم/ساعة',
  'common.aed': 'درهم',
  'common.classes': 'حصص',

  // Alerts
  'alerts.required_fields': 'يرجى تعبئة جميع الحقول المطلوبة',
  'alerts.all_fields': 'يرجى تعبئة جميع الحقول',
  'alerts.generic_error': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'alerts.submit_failed': 'فشل الإرسال. يرجى المحاولة مرة أخرى.',
  'alerts.invalid_credentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  'alerts.password_min': 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
  'alerts.registration_failed': 'فشل التسجيل. يرجى المحاولة مرة أخرى.',
  'alerts.email_not_verified': 'يرجى التحقق من بريدك الإلكتروني قبل تسجيل الدخول.',
  'alerts.attendance_saved': 'تم حفظ الحضور بنجاح!',
  'alerts.attendance_save_failed': 'فشل حفظ الحضور',

  // Hero
  'hero.programs': 'برامجنا',
  'hero.certified_courses': 'الدورات المعتمدة',
  'hero.courses_subtitle': 'اختر من مجموعة دوراتنا المعترف بها دولياً والمصممة لكل مستوى وهدف.',
  'hero.cta_primary': 'استكشف الدورات',
  'hero.cta_secondary': 'اختبار تحديد المستوى',
  'hero.image_alt': 'طلاب في فصل حديث',

  // Courses
  'courses.title': 'الدورات',
  'courses.english_courses': 'دورات اللغة الإنجليزية',
  'courses.subtitle': 'استكشف مجموعتنا الشاملة من دورات اللغة الإنجليزية المصممة لكل مستوى وهدف تعليمي.',
  'courses.all_levels': 'جميع المستويات',
  'courses.all_modalities': 'جميع الأنماط',
  'courses.in_person': 'حضوري',
  'courses.online': 'عبر الإنترنت',
  'courses.hybrid': 'مختلط',
  'courses.level_beginner': 'مبتدئ',
  'courses.level_elementary': 'أساسي',
  'courses.level_intermediate': 'متوسط',
  'courses.level_upper_intermediate': 'فوق المتوسط',
  'courses.level_advanced': 'متقدم',
  'courses.level_proficiency': 'إتقان',
  'courses.details': 'التفاصيل',
  'courses.enroll_now': 'سجل الآن',
  'courses.duration': 'المدة',
  'courses.class_size': 'حجم الصف',
  'courses.view_all': 'عرض جميع الدورات',
  'courses.found': 'دورة',
  'courses.no_courses': 'لم يتم العثور على دورات',
  'courses.try_filters': 'حاول تعديل الفلاتر لرؤية الدورات المتاحة.',
  'courses.format': 'النمط',
  'courses.schedule': 'الجدول',
  'courses.features': 'مميزات الدورة',

  // Enrollment
  'enroll.title': 'الالتحاق بالدورة',
  'enroll.processing': 'جارٍ معالجة التسجيل...',
  'enroll.success': 'تم التسجيل بنجاح.',
  'enroll.failed': 'فشل التسجيل.',
  'enroll.missing_course': 'لم يتم اختيار دورة.',
  'enroll.go_dashboard': 'الذهاب إلى لوحة التحكم',
  'enroll.back_courses': 'العودة إلى الدورات',
  'enroll.schedule_desc': 'أضف جدولك المفضل ليساعد الإدارة على تعيين حصصك بشكل أسرع.',
  'enroll.sessions_per_week': 'عدد الحصص أسبوعياً',
  'enroll.sessions_per_week_hint': 'يتم احتسابه تلقائياً من الأيام والأوقات المحددة أدناه.',
  'enroll.apply_schedule_after': 'تطبيق الجدول بعد',
  'enroll.preferred_weekly_schedule': 'الجدول الأسبوعي المفضل',
  'enroll.day': 'اليوم',
  'enroll.include': 'تضمين',
  'enroll.start': 'البداية',
  'enroll.end': 'النهاية',
  'enroll.choose_schedule_row': 'يرجى اختيار موعد واحد على الأقل.',
  'enroll.invalid_time_range': 'يرجى إدخال وقت صحيح ليوم {day}.',
  'days.monday': 'الاثنين',
  'days.tuesday': 'الثلاثاء',
  'days.wednesday': 'الأربعاء',
  'days.thursday': 'الخميس',
  'days.friday': 'الجمعة',
  'days.saturday': 'السبت',
  'days.sunday': 'الأحد',

  // Why Choose Us
  'why.title': 'لماذا يختارنا الطلاب',
  'why.kicker': 'لماذا بيفلونت',

  // Steps
  'steps.title': 'خطوات الانضمام إلى بيفلونت',
  'steps.kicker': 'كيف يعمل النظام',

  // Stats
  'stats.kicker': 'إحصائياتنا',

  // Testimonials
  'testimonials.title': 'ماذا يقول طلابنا',
  'testimonials.kicker': 'آراء الطلاب',

  // Lead Capture
  'lead.title': 'ابدأ رحلتك اليوم',
  'lead.kicker': 'تواصل معنا',
  'lead.subtitle': 'املأ النموذج وسيتواصل معك أحد مستشارينا خلال 24 ساعة لمناقشة أهدافك والتوصية بالدورة المثالية لك.',
  'lead.benefit1': 'اختبار تحديد مستوى واستشارة مجانية',
  'lead.benefit2': 'توصيات مخصصة للدورات',
  'lead.benefit3': 'خيارات دفع مرنة',
  'lead.benefit4': 'دعم بلغات متعددة',
  'lead.full_name': 'الاسم الكامل',
  'lead.email': 'البريد الإلكتروني',
  'lead.phone': 'الهاتف',
  'lead.course_interest': 'الدورة المهتم بها',
  'lead.select_course': 'اختر دورة',
  'lead.send': 'إرسال الاستفسار',
  'lead.submitting': 'جاري الإرسال...',
  'lead.success': 'شكراً لك! سيتواصل معك فريقنا خلال 24 ساعة.',

  // CTA Banner
  'cta.title': 'هل أنت مستعد لبدء رحلتك في تعلم الإنجليزية؟',
  'cta.subtitle': 'خذ اختبار تحديد المستوى المجاني لاكتشاف مستواك الحالي والحصول على توصيات مخصصة.',
  'cta.placement': 'اختبار تحديد مستوى مجاني',
  'cta.contact': 'اتصل بنا',

  // Placement Test
  'placement.title': 'اختبار تحديد المستوى',
  'placement.subtitle': 'اكتشف مستواك الحالي في اللغة الإنجليزية من خلال اختبارنا الشامل.',
  'placement.intro_title': 'مقدمة الاختبار',
  'placement.intro_sub': 'يرجى قراءة التعليمات قبل البدء.',
  'placement.intro_ok': 'ابدأ الآن',
  'placement.free': 'تقييم مجاني',
  'placement.info1': 'سؤال، حوالي 15-20 دقيقة',
  'placement.info2': 'يغطي القواعد والمفردات والقراءة',
  'placement.info3': 'تقييم مستويات CEFR من A1 إلى C2',
  'placement.start': 'ابدأ الاختبار',
  'placement.question': 'سؤال',
  'placement.of': 'من',
  'placement.answered': 'تمت الإجابة',
  'placement.previous': 'السابق',
  'placement.next': 'التالي',
  'placement.finish': 'إنهاء',
  'placement.complete': 'اكتمل الاختبار!',
  'placement.complete_sub': 'لقد أجبت على {answered} من أصل {total} سؤال. أدخل بياناتك لرؤية النتائج.',
  'placement.first_name': 'الاسم الأول',
  'placement.last_name': 'اسم العائلة',
  'placement.see_results': 'عرض النتائج',
  'placement.analyzing': 'جاري تحليل النتائج...',
  'placement.your_results': 'نتائجك',
  'placement.results_sub': 'بناءً على إجاباتك، هذا مستواك المقيّم في اللغة الإنجليزية.',
  'placement.your_level': 'مستواك',
  'placement.score': 'حصلت على {score} من {total} ({percentage}%)',
  'placement.recommended': 'الدورات الموصى بها',
  'placement.whats_next': 'ما التالي؟',
  'placement.team_contact': 'سيقوم فريقنا بمراجعة نتائجك والتواصل معك خلال 24 ساعة مع توصيات مخصصة.',
  'placement.view_courses': 'عرض الدورات',
  'placement.grammar': 'القواعد',
  'placement.vocabulary': 'المفردات',
  'placement.reading': 'القراءة',

  // About
  'about.title': 'من نحن',
  'about.mission': 'مهمتنا',
  'about.vision': 'رؤيتنا',
  'about.values_title': 'قيمنا',
  'about.values_kicker': 'ما يدفعنا',
  'about.campus_kicker': 'حرمنا الجامعي',
  'about.join_title': 'هل أنت مستعد للانضمام إلى مجتمعنا؟',
  'about.join_sub': 'اتخذ الخطوة الأولى نحو إتقان الإنجليزية مع اختبار تحديد مستوى مجاني.',

  // Contact
  'contact.title': 'تواصل معنا',
  'contact.subtitle': 'هل لديك سؤال أو مستعد للتسجيل؟ فريقنا هنا لمساعدتك في كل خطوة.',
  'contact.send': 'إرسال الرسالة',
  'contact.sending': 'جاري الإرسال...',
  'contact.name': 'الاسم',
  'contact.email': 'البريد الإلكتروني',
  'contact.phone': 'الهاتف',
  'contact.subject': 'الموضوع',
  'contact.message': 'الرسالة',
  'contact.visit': 'زورنا',
  'contact.call': 'اتصل بنا',
  'contact.email_us': 'راسلنا',
  'contact.hours': 'ساعات العمل',
  'contact.send_message': 'إرسال رسالة',
  'contact.success': 'تم إرسال الرسالة! سنعاود التواصل معك قريباً.',
  'contact.failed': 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',

  // Auth
  'auth.sign_in': 'تسجيل الدخول',
  'auth.sign_in_desc': 'أدخل بياناتك للوصول إلى حسابك',
  'auth.create_account': 'إنشاء حساب',
  'auth.create_desc': 'املأ بياناتك للبدء',
  'auth.email': 'البريد الإلكتروني',
  'auth.password': 'كلمة المرور',
  'auth.first_name': 'الاسم الأول',
  'auth.last_name': 'اسم العائلة',
  'auth.phone': 'الهاتف',
  'auth.code': 'الرمز',
  'auth.signing_in': 'جاري تسجيل الدخول...',
  'auth.creating': 'جاري إنشاء الحساب...',
  'auth.no_account': 'ليس لديك حساب؟',
  'auth.has_account': 'لديك حساب بالفعل؟',
  'auth.create_one': 'أنشئ حساباً',
  'auth.sign_in_link': 'سجل الدخول',
  'auth.demo_accounts': 'حسابات تجريبية:',
  'auth.demo_student': 'طالب',
  'auth.demo_teacher': 'معلم',
  'auth.demo_admin': 'مدير',
  'auth.welcome_back': 'مرحباً بعودتك إلى رحلة التعلم',
  'auth.welcome_desc': 'الوصول إلى لوحة التحكم المخصصة لك، تتبع تقدمك، واستمر في طريقك نحو إتقان الإنجليزية.',
  'auth.track': 'تتبع تقدمك',
  'auth.access_materials': 'الوصول إلى المواد الدراسية',
  'auth.view_schedule': 'عرض جدولك',
  'auth.begin_journey': 'ابدأ رحلتك نحو الطلاقة',
  'auth.begin_desc': 'أنشئ حسابك وانضم إلى آلاف الطلاب من حول العالم في إتقان اللغة الإنجليزية.',
  'auth.personalized': 'مسار تعلم مخصص',
  'auth.progress': 'تتبع التقدم',
  'auth.course_access': 'الوصول إلى مواد الدورات',
  'auth.community': 'الوصول إلى المجتمع',
  'auth.min_chars': 'الحد الأدنى 6 أحرف',
  'auth.forgot_password': 'نسيت كلمة المرور؟',
  'auth.reset_password': 'إعادة تعيين كلمة المرور',
  'auth.reset_password_desc': 'أدخل كلمة مرور جديدة لحسابك.',
  'auth.reset_request_desc': 'أدخل بريدك الإلكتروني وسنرسل لك رابطاً آمناً لإعادة تعيين كلمة المرور.',
  'auth.reset_request_sent_desc': 'إذا كان البريد مسجلاً، افتح رابط إعادة التعيين الذي أرسلناه لك.',
  'auth.send_reset_link': 'إرسال رابط إعادة التعيين',
  'auth.sending_reset': 'جارٍ إرسال الرابط...',
  'auth.reset_request_success': 'تم إرسال رابط إعادة تعيين كلمة المرور.',
  'auth.reset_success': 'تم تغيير كلمة المرور بنجاح.',
  'auth.reset_missing_token': 'رابط إعادة التعيين غير صالح.',
  'auth.new_password': 'كلمة المرور الجديدة',
  'auth.confirm_password': 'تأكيد كلمة المرور',
  'auth.passwords_do_not_match': 'كلمتا المرور غير متطابقتين.',

  // Verify Email
  'verify.check_title': 'تحقق من بريدك الإلكتروني',
  'verify.check_desc': 'لقد أرسلنا رابط تحقق إلى',
  'verify.check_desc_no_email': 'لقد أرسلنا رابط تحقق إلى بريدك الإلكتروني. يرجى فتحه للتحقق من حسابك.',
  'verify.resend': 'إعادة إرسال البريد',
  'verify.resending': 'جاري إعادة الإرسال...',
  'verify.resend_success': 'تم إرسال بريد التحقق بنجاح.',
  'verify.resend_failed': 'فشل إعادة الإرسال. يرجى المحاولة مرة أخرى.',
  'verify.success_title': 'تم التحقق من البريد',
  'verify.success_desc': 'تم التحقق من بريدك الإلكتروني. يمكنك الآن تسجيل الدخول.',
  'verify.failed_title': 'فشل التحقق',
  'verify.failed_desc': 'رابط التحقق غير صالح أو منتهي الصلاحية.',
  'verify.missing_title': 'رابط ناقص',
  'verify.missing_desc': 'لم يتم العثور على رمز تحقق.',
  'verify.back_login': 'العودة إلى تسجيل الدخول',

  // About
  'about.hero_title_line1': 'نمكّن التعلم العالمي',
  'about.hero_title_accent': 'بطلاقة',
  'about.hero_image_alt': 'مجتمع الطلاب',
  'about.campus_title_prefix': 'مرافق بمعايير عالمية',
  'about.campus_title_accent': 'متميزة',

  // Dashboard
  'dashboard.welcome': 'مرحباً بعودتك،',
  'dashboard.overview': 'إليك نظرة عامة على تقدمك التعليمي',
  'dashboard.current_level': 'المستوى الحالي',
  'dashboard.level_label': 'المستوى',
  'dashboard.next_label': 'التالي',
  'dashboard.intermediate': 'متوسط',
  'dashboard.attendance': 'الحضور',
  'dashboard.classes': 'حصة',
  'dashboard.next_class': 'الحصة القادمة',
  'dashboard.dont_miss': 'لا تفوتها!',
  'dashboard.upcoming_classes': 'الحصص القادمة',
  'dashboard.upcoming_classes_subtitle': 'حصصك المعتمدة القادمة',
  'dashboard.no_upcoming_classes': 'لا توجد حصص قادمة حالياً.',
  'dashboard.my_courses': 'دوراتي',
  'dashboard.payments': 'المدفوعات',
  'dashboard.notifications': 'الإشعارات',
  'dashboard.no_notifications': '\u0644\u0627 \u062a\u0648\u062c\u062f \u0625\u0634\u0639\u0627\u0631\u0627\u062a \u0628\u0639\u062f.',
  'dashboard.explore_title': 'ابدأ رحلتك بعرض الدورات المتاحة',
  'dashboard.explore_subtitle': 'استكشف الدورات وسجل للانتقال إلى مستواك القادم.',
  'dashboard.explore_action': 'استكشف الدورات',
  'dashboard.no_courses_title': 'لا توجد دورات مسجلة حالياً',
  'dashboard.no_courses_subtitle': 'تصفح الدورات المتاحة واختر ما يناسبك.',
  'dashboard.description': 'الوصف',
  'dashboard.date': 'التاريخ',
  'dashboard.amount': 'المبلغ',
  'dashboard.status': 'الحالة',
  'dashboard.payment_method': 'طريقة الدفع',
  'dashboard.reference': 'المرجع',
  'dashboard.invoice': 'الفاتورة',
  'dashboard.no_payments': 'لا توجد فواتير أو مدفوعات حالياً.',

  // Teacher Dashboard
  'teacher.welcome': 'مرحباً،',
  'teacher.overview': 'إدارة حصصك وتتبع حضور الطلاب',
  'teacher.today_classes': 'حصصي',
  'teacher.total_groups': 'إجمالي المجموعات',
  'teacher.hours_month': 'ساعات هذا الشهر',
  'teacher.classes_month': 'حصص هذا الشهر',
  'teacher.schedule': 'حصصي',
  'teacher.my_classes': 'حصصي',
  'teacher.schedule_requests': 'طلبات الجدول',
  'teacher.schedule_type': 'نوع الجدول',
  'teacher.weekly_schedule': 'جدول أسبوعي',
  'teacher.flexible_schedule': 'جدول مرن',
  'teacher.attendance': 'الحضور',
  'teacher.hours': 'نظرة على الساعات',
  'teacher.time': 'الوقت',
  'teacher.course': 'الدورة',
  'teacher.group': 'المجموعة',
  'teacher.room': 'القاعة',
  'teacher.students': 'الطلاب',
  'teacher.present': 'حاضر',
  'teacher.student': 'الطالب',
  'teacher.level': 'المستوى',
  'teacher.att_percent': 'نسبة الحضور %',
  'teacher.save': 'حفظ',
  'teacher.monthly_hours': 'تفصيل الساعات الشهرية',
  'teacher.total_month': 'الإجمالي هذا الشهر',
  'teacher.duration_hours': 'مدة الحصة بالساعات',
  'teacher.salary_period': 'اختر الفترة لاستخراج كشف الراتب',
  'teacher.date_from': 'من تاريخ',
  'teacher.date_to': 'إلى تاريخ',
  'teacher.generate_salary_slip': 'تحديث الكشف',
  'teacher.print_slip': 'طباعة الكشف',
  'teacher.total_hours': 'إجمالي الساعات',
  'teacher.total_sessions': 'إجمالي الحصص',
  'teacher.hourly_rate': 'سعر الساعة',
  'teacher.salary_due': 'الراتب المستحق',
  'teacher.allowance': 'بدل المواصلات',
  'teacher.session_history': 'سجل الحصص',
  'teacher.no_sessions': 'لا توجد حصص مسجلة في هذه الفترة',
  'teacher.explore_title': 'لا يوجد جدول أو مجموعات حالياً',
  'teacher.explore_subtitle': 'يمكنك البدء بتصفح الدورات المتاحة.',
  'teacher.explore_action': 'استكشف الدورات',
  'teacher.no_schedule': 'لا يوجد جدول متاح حالياً',
  'teacher.no_groups_title': 'لا توجد مجموعات حالياً',
  'teacher.no_groups_subtitle': 'ستظهر المجموعات هنا عند إسنادها إليك.',
  'teacher.sessions': 'الحصص',
  'teacher.notifications_on': 'الإشعارات مفعلة',
  'teacher.enable_notifications': 'تفعيل الإشعارات',
  'teacher.class_type': 'نوع الصف',
  'teacher.class_type_group': 'حصة جماعية',
  'teacher.class_type_mini_group': 'مجموعة صغيرة',
  'teacher.class_type_vip': 'حصة VIP خاصة (فردية)',
  'teacher.session_type': 'نوع الحصة',
  'teacher.days': 'الأيام',
  'teacher.start_after': 'تبدأ بعد',
  'teacher.mode': 'النمط',
  'teacher.progress': 'التقدم',
  'teacher.total': 'الإجمالي',
  'teacher.completed': 'مكتملة',
  'teacher.remaining': 'المتبقي',
  'teacher.type': 'النوع',
  'teacher.action': 'الإجراء',
  'teacher.actions': 'الإجراءات',
  'teacher.class_plan': 'خطة الدرس',
  'teacher.package': 'الباقة',
  'teacher.lesson_plan': 'خطة الدرس',
  'teacher.topics_taught': 'المواضيع التي تم تدريسها',
  'teacher.links': 'الروابط',
  'teacher.materials_notes': 'ملاحظات المواد',
  'teacher.upload_files': 'رفع ملفات',
  'teacher.save_class_plan': 'حفظ خطة الدرس',
  'teacher.delete_attachment': 'حذف',
  'teacher.remove_file': 'إزالة',
  'teacher.sessions_per_week': 'الحصص/الأسبوع',
  'teacher.group_approval': 'موافقة مجموعة',
  'teacher.accept': 'قبول',
  'teacher.request_change': 'طلب تعديل',
  'teacher.no_action_needed': 'لا يوجد إجراء مطلوب',
  'teacher.no_schedule_requests': 'لا توجد طلبات جدول بعد.',
  'teacher.attendance_status': 'حالة الحضور',
  'teacher.current_value': 'القيمة الحالية',
  'teacher.absent': 'غائب',
  'teacher.late': 'متأخر',
  'teacher.no_attendance_sessions': 'لا توجد حصص منشأة متاحة للحضور.',
  'teacher.attendance_sessions_hint': 'يتم تسجيل الحضور على الحصص المجدولة بعد موافقة المعلم.',
  'teacher.no_students_linked_session': 'لا يوجد طلاب مرتبطون بهذه الحصة.',
  'teacher.applied_rates': 'الأسعار المطبقة',
  'teacher.no_completed_sessions': 'لا توجد حصص مكتملة',
  'teacher.sessions_lower': 'حصص',
  'teacher.rate': 'السعر',
  'teacher.teaching': 'التدريس',
  'teacher.transportation': 'المواصلات',
  'teacher.title': 'العنوان',
  'teacher.message': 'الرسالة',
  'teacher.clear': 'مسح',
  'teacher.no_notifications': 'لا توجد إشعارات بعد.',
  'teacher.notification_cleared': 'تم مسح الإشعار.',
  'teacher.no_generated_sessions_period': 'لا توجد حصص منشأة في هذه الفترة.',
  'teacher.in_office': 'داخل المركز',
  'teacher.loading_class_details': 'جارٍ تحميل تفاصيل الصف...',
  'teacher.class_details_load_failed': 'تعذر تحميل تفاصيل الصف.',
  'teacher.schedule_requests_load_failed': 'تعذر تحميل طلبات الجدول. يرجى تحديث الصفحة.',
  'teacher.schedule_accepted': 'تم قبول الجدول.',
  'teacher.schedule_change_prompt': 'ما التعديلات المطلوبة على هذا الجدول؟',
  'teacher.change_request_sent': 'تم إرسال طلب التعديل إلى الإدارة.',
  'teacher.class_plan_saved': 'تم حفظ خطة الدرس.',
  'teacher.attachment_deleted': 'تم حذف الملف.',
  'teacher.desktop_notifications_enabled': 'تم تفعيل إشعارات سطح المكتب.',
  'teacher.browser_notifications_blocked': 'إشعارات المتصفح محظورة. يرجى السماح بها من إعدادات المتصفح.',
  'teacher.browser_notifications_unsupported': 'هذا المتصفح لا يدعم إشعارات سطح المكتب.',
  'teacher.package_completed': 'اكتملت الباقة',
  'teacher.progress_completed': 'مكتملة',
  'teacher.progress_remaining': 'المتبقي',
  'teacher.state_scheduled': 'مجدولة',
  'teacher.state_in_progress': 'قيد التنفيذ',
  'teacher.state_complete': 'مكتملة',
  'teacher.state_postponed': 'مؤجلة',
  'teacher.state_holiday': 'عطلة',
  'teacher.state_cancelled': 'ملغاة',
  'teacher.class_plan_submitted': 'تم الإرسال',
  'teacher.class_plan_missing': 'غير مكتملة',
  'teacher.status_pending_teacher': 'بانتظار المعلم',
  'teacher.status_change_requested': 'طلب تعديل',
  'teacher.status_accepted': 'مقبول',
  'teacher.status_rejected': 'مرفوض',


  // Social
  'social.kicker': 'تابعنا',
  'social.title': 'آخر منشوراتنا',

  // Preferences
  'pref.title': 'أخبرنا عن تفضيلاتك',
  'pref.subtitle': 'ساعدنا في التوصية بأفضل دورة لك.',
  'pref.contact_method': 'طريقة التواصل المفضلة',
  'pref.phone_call': 'مكالمة هاتفية',
  'pref.course_format': 'نمط الدورة',
  'pref.private': 'خاصة',
  'pref.group': 'مجموعة',
  'pref.mini_group': 'مجموعة صغيرة',
  'pref.language': 'اللغة',
  'pref.select_language': 'اختر اللغة',
  'pref.course_type': 'نوع الدورة',
  'pref.select_type': 'اختر نوع الدورة',
  'pref.heard_from': 'كيف سمعت عنا؟',
  'pref.select_source': 'اختر المصدر',
  'pref.src_website': 'الموقع الإلكتروني',
  'pref.src_email': 'البريد الإلكتروني',
  'pref.src_google': 'بحث جوجل',
  'pref.src_referral': 'إحالة',
  'pref.src_other': 'أخرى',
  'pref.notes': 'ملاحظات إضافية',
  'pref.notes_placeholder': 'أي متطلبات أو أسئلة محددة...',

  // Footer
  'footer.courses': 'دوراتنا',
  'footer.quick_links': 'روابط سريعة',
  'footer.contact': 'اتصل بنا',
  'footer.brand_description': 'نمكّن المتعلمين حول العالم من خلال تعليم اللغة الإنجليزية بمعايير عالمية في قلب دبي.',
  'footer.rights': 'جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'الشروط والأحكام',

  // Language
  'lang.switch_to_ar': 'العربية',
  'lang.switch_to_en': 'English',
  'lang.short_ar': 'ع',
  'lang.short_en': 'EN',

  // Theme
  'theme.switch_to_light': 'الوضع الفاتح',
  'theme.switch_to_dark': 'الوضع الداكن',

  // UI
  'ui.breadcrumb': 'مسار التنقل',
  'ui.more': 'المزيد',
  'ui.carousel': 'عارض الشرائح',
  'ui.slide': 'شريحة',
  'ui.prev_slide': 'الشريحة السابقة',
  'ui.next_slide': 'الشريحة التالية',
  'ui.close': 'إغلاق',
  'ui.pagination': 'ترقيم الصفحات',
  'ui.prev_page': 'الانتقال إلى الصفحة السابقة',
  'ui.next_page': 'الانتقال إلى الصفحة التالية',
  'ui.previous': 'السابق',
  'ui.next': 'التالي',
  'ui.more_pages': 'صفحات إضافية',

  'courses.search_placeholder': 'ابحث عن دورة',
  'courses.audience': 'الفئة',
  'courses.audience_all': 'الكل',
  'courses.audience_individual': 'فردي',
  'courses.audience_corporate': 'شركات',
  'courses.contact_us': 'تواصل معنا',
  'courses.corporate_no_price': 'السعر متاح عند الطلب',

  'contact.company_name': 'اسم الشركة',
  'contact.employees_range': 'عدد الموظفين',
  'contact.work_email': 'البريد الإلكتروني للعمل',
  'contact.notes': 'ملاحظات',
  'contact.employees_1_10': '1-10',
  'contact.employees_11_50': '11-50',
  'contact.employees_51_100': '51-100',
  'contact.employees_101_250': '101-250',
  'contact.employees_251_500': '251-500',
  'contact.employees_500_plus': '500+',

  'corporate.kicker': 'دورات الشركات',
  'corporate.title': 'دورات الشركات (سهلة الوصول)',
  'corporate.subtitle': 'حلول تدريب مرنة للشركات بجداول مخصصة ونتائج قابلة للقياس.',
  'packages.english_title': 'باقات الإنجليزية',
  'packages.arabic_title': 'باقات العربية',
  'packages.other_title': 'باقات اللغات الأخرى',
};

export const en = {
  'brand.name': 'Be Fluent',
  'brand.full_name': 'Be Fluent Language Center',
  'brand.alt': 'Be Fluent logo',
  'nav.home': 'Home',
  'nav.courses': 'Courses',
  'nav.languages': 'Languages',
  'nav.placement_test': 'Placement Test',
  'nav.packages': 'Packages',
  'nav.corporate': 'Corporate',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.login': 'Log in',
  'nav.register': 'Get Started',
  'nav.dashboard': 'Dashboard',
  'nav.logout': 'Logout',
  'common.submit': 'Submit',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.loading': 'Loading...',
  'common.required': 'Required',
  'common.code': 'Code',
  'common.details': 'Details',
  'common.view_all': 'View All',
  'common.enrolling_now': 'Enrolling Now',
  'common.join_community': 'Join our global community',
  'common.per_course': 'per course',
  'common.aed_hr': 'AED/hr',
  'common.aed': 'AED',
  'common.classes': 'classes',
  'alerts.required_fields': 'Please fill in all required fields',
  'alerts.all_fields': 'Please fill in all fields',
  'alerts.generic_error': 'Something went wrong. Please try again.',
  'alerts.submit_failed': 'Failed to submit. Please try again.',
  'alerts.invalid_credentials': 'Invalid email or password',
  'alerts.password_min': 'Password must be at least 6 characters',
  'alerts.registration_failed': 'Registration failed. Please try again.',
  'alerts.email_not_verified': 'Please verify your email before logging in.',
  'alerts.attendance_saved': 'Attendance saved successfully!',
  'alerts.attendance_save_failed': 'Failed to save attendance',
  'hero.programs': 'OUR PROGRAMS',
  'hero.certified_courses': 'Certified English Courses',
  'hero.courses_subtitle': 'Choose from our range of internationally recognized courses designed for every level and goal.',
  'hero.cta_primary': 'Explore Courses',
  'hero.cta_secondary': 'Take Placement Test',
  'hero.image_alt': 'Students in a modern classroom',
  'courses.title': 'Courses',
  'courses.english_courses': 'English Courses',
  'courses.subtitle': 'Explore our comprehensive range of English language courses designed for every level and learning goal.',
  'courses.all_levels': 'All Levels',
  'courses.all_modalities': 'All Modalities',
  'courses.in_person': 'In-person',
  'courses.online': 'Online',
  'courses.hybrid': 'Hybrid',
  'courses.level_beginner': 'Beginner',
  'courses.level_elementary': 'Elementary',
  'courses.level_intermediate': 'Intermediate',
  'courses.level_upper_intermediate': 'Upper Intermediate',
  'courses.level_advanced': 'Advanced',
  'courses.level_proficiency': 'Proficiency',
  'courses.details': 'Details',
  'courses.enroll_now': 'Enroll Now',
  'courses.duration': 'Duration',
  'courses.class_size': 'Class Size',
  'courses.view_all': 'View All Courses',
  'courses.found': 'courses found',
  'courses.no_courses': 'No courses found',
  'courses.try_filters': 'Try adjusting your filters to see available courses.',
  'courses.format': 'Format',
  'courses.schedule': 'Schedule',
  'courses.features': 'Course Features',

  'courses.search_placeholder': 'Search courses',
  'courses.audience': 'Audience',
  'courses.audience_all': 'All',
  'courses.audience_individual': 'Individual',
  'courses.audience_corporate': 'Corporate',
  'courses.contact_us': 'Contact Us',
  'courses.corporate_no_price': 'Price available upon request',

  // Enrollment
  'enroll.title': 'Course Enrollment',
  'enroll.processing': 'Processing your enrollment...',
  'enroll.success': 'Enrollment successful.',
  'enroll.failed': 'Enrollment failed.',
  'enroll.missing_course': 'Course not selected.',
  'enroll.go_dashboard': 'Go to Dashboard',
  'enroll.back_courses': 'Back to Courses',
  'enroll.schedule_desc': 'Add your preferred schedule so the admin can assign your classes faster.',
  'enroll.sessions_per_week': 'Sessions per week',
  'enroll.sessions_per_week_hint': 'This is calculated automatically from the selected days and times below.',
  'enroll.apply_schedule_after': 'Apply schedule after',
  'enroll.preferred_weekly_schedule': 'Preferred weekly schedule',
  'enroll.day': 'Day',
  'enroll.include': 'Include',
  'enroll.start': 'Start',
  'enroll.end': 'End',
  'enroll.choose_schedule_row': 'Please choose at least one schedule row.',
  'enroll.invalid_time_range': 'Please provide a valid time range for {day}.',
  'days.monday': 'Monday',
  'days.tuesday': 'Tuesday',
  'days.wednesday': 'Wednesday',
  'days.thursday': 'Thursday',
  'days.friday': 'Friday',
  'days.saturday': 'Saturday',
  'days.sunday': 'Sunday',
  'why.title': 'Why Students Choose Us',
  'why.kicker': 'WHY BEFLUENT',
  'steps.title': 'Steps to Join Be Fluent',
  'steps.kicker': 'HOW IT WORKS',
  'stats.kicker': 'OUR STATS',
  'testimonials.title': 'What Our Students Say',
  'testimonials.kicker': 'TESTIMONIALS',
  'lead.title': 'Start Your Journey Today',
  'lead.kicker': 'GET IN TOUCH',
  'lead.subtitle': 'Fill out the form and one of our advisors will contact you within 24 hours to discuss your goals and recommend the perfect course for you.',
  'lead.benefit1': 'Free placement test & consultation',
  'lead.benefit2': 'Personalized course recommendations',
  'lead.benefit3': 'Flexible payment options',
  'lead.benefit4': 'Support in multiple languages',
  'lead.full_name': 'Full Name',
  'lead.email': 'Email',
  'lead.phone': 'Phone',
  'lead.course_interest': 'Interested Course',
  'lead.select_course': 'Select a course',
  'lead.send': 'Send Inquiry',
  'lead.submitting': 'Submitting...',
  'lead.success': 'Thank you! Our team will contact you within 24 hours.',
  'cta.title': 'Ready to Start Your English Journey?',
  'cta.subtitle': 'Take our free placement test to discover your current level and get personalized course recommendations.',
  'cta.placement': 'Free Placement Test',
  'cta.contact': 'Contact Us',
  'placement.title': 'English Placement Test',
  'placement.subtitle': 'Discover your current English level with our comprehensive placement test.',
  'placement.intro_title': 'Test Introduction',
  'placement.intro_sub': 'Please read the instructions before starting.',
  'placement.intro_ok': 'Start Now',
  'placement.free': 'Free Assessment',
  'placement.info1': 'Question, about 15-20 minutes',
  'placement.info2': 'Covers grammar, vocabulary, and reading',
  'placement.info3': 'Assesses CEFR levels from A1 to C2',
  'placement.start': 'Start Test',
  'placement.question': 'Question',
  'placement.of': 'of',
  'placement.answered': 'answered',
  'placement.previous': 'Previous',
  'placement.next': 'Next',
  'placement.finish': 'Finish',
  'placement.complete': 'Test Complete!',
  'placement.complete_sub': 'You answered {answered} out of {total} questions. Enter your details to see results.',
  'placement.first_name': 'First Name',
  'placement.last_name': 'Last Name',
  'placement.see_results': 'See My Results',
  'placement.analyzing': 'Analyzing Results...',
  'placement.your_results': 'Your Results',
  'placement.results_sub': "Based on your answers, here's your assessed English level.",
  'placement.your_level': 'Your Level',
  'placement.score': 'You scored {score} out of {total} ({percentage}%)',
  'placement.recommended': 'Recommended Courses',
  'placement.whats_next': "What's Next?",
  'placement.team_contact': 'Our team will review your results and contact you within 24 hours with personalized recommendations.',
  'placement.view_courses': 'View Courses',
  'placement.grammar': 'Grammar',
  'placement.vocabulary': 'Vocabulary',
  'placement.reading': 'Reading',
  'about.title': 'About Us',
  'about.mission': 'Our Mission',
  'about.vision': 'Our Vision',
  'about.values_title': 'What Drives Us',
  'about.values_kicker': 'OUR VALUES',
  'about.campus_kicker': 'OUR CAMPUS',
  'about.join_title': 'Ready to Join Our Community?',
  'about.join_sub': 'Take the first step towards English fluency with a free placement test.',
  'contact.title': 'Get in Touch',
  'contact.subtitle': 'Have a question or ready to enroll? Our team is here to help you every step of the way.',
  'contact.send': 'Send Message',

  'contact.company_name': 'Company Name',
  'contact.employees_range': 'Employees Range',
  'contact.work_email': 'Work Email',
  'contact.notes': 'Notes',
  'contact.employees_1_10': '1-10',
  'contact.employees_11_50': '11-50',
  'contact.employees_51_100': '51-100',
  'contact.employees_101_250': '101-250',
  'contact.employees_251_500': '251-500',
  'contact.employees_500_plus': '500+',
  'contact.sending': 'Sending...',
  'contact.name': 'Name',
  'contact.email': 'Email',
  'contact.phone': 'Phone',
  'contact.subject': 'Subject',
  'contact.message': 'Message',
  'contact.visit': 'Visit Us',
  'contact.call': 'Call Us',
  'contact.email_us': 'Email Us',
  'contact.hours': 'Working Hours',
  'contact.send_message': 'Send a Message',
  'contact.success': 'Message sent! We will get back to you shortly.',
  'contact.failed': 'Failed to send message. Please try again.',
  'auth.sign_in': 'Sign In',
  'auth.sign_in_desc': 'Enter your credentials to access your account',
  'auth.create_account': 'Create Account',
  'auth.create_desc': 'Fill in your details to get started',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.first_name': 'First Name',
  'auth.last_name': 'Last Name',
  'auth.phone': 'Phone',
  'auth.code': 'Code',
  'auth.signing_in': 'Signing in...',
  'auth.creating': 'Creating Account...',
  'auth.no_account': "Don't have an account?",
  'auth.has_account': 'Already have an account?',
  'auth.create_one': 'Create one',
  'auth.sign_in_link': 'Sign in',
  'auth.demo_accounts': 'Demo Accounts:',
  'auth.demo_student': 'Student',
  'auth.demo_teacher': 'Teacher',
  'auth.demo_admin': 'Admin',
  'auth.welcome_back': 'Welcome back to your learning journey',
  'auth.welcome_desc': 'Access your personalized dashboard, track your progress, and continue your path to English fluency.',
  'auth.track': 'Track your progress',
  'auth.access_materials': 'Access study materials',
  'auth.view_schedule': 'View your schedule',
  'auth.begin_journey': 'Begin your journey to fluency',
  'auth.begin_desc': 'Create your account and join thousands of students from around the world in mastering the English language.',
  'auth.personalized': 'Personalized learning path',
  'auth.progress': 'Progress tracking',
  'auth.course_access': 'Access to course materials',
  'auth.community': 'Community access',
  'auth.min_chars': 'Min 6 characters',
  'auth.forgot_password': 'Forgot Password?',
  'auth.reset_password': 'Reset Password',
  'auth.reset_password_desc': 'Enter a new password for your account.',
  'auth.reset_request_desc': 'Enter your email and we will send a secure password reset link.',
  'auth.reset_request_sent_desc': 'If the email is registered, open the reset link we sent you.',
  'auth.send_reset_link': 'Send Reset Link',
  'auth.sending_reset': 'Sending reset link...',
  'auth.reset_request_success': 'Password reset link sent.',
  'auth.reset_success': 'Password changed successfully.',
  'auth.reset_missing_token': 'This reset link is invalid.',
  'auth.new_password': 'New Password',
  'auth.confirm_password': 'Confirm Password',
  'auth.passwords_do_not_match': 'Passwords do not match.',

  // Verify Email
  'verify.check_title': 'Check your email',
  'verify.check_desc': 'We sent a verification link to',
  'verify.check_desc_no_email': 'We sent a verification link to your email. Please open it to verify your account.',
  'verify.resend': 'Resend email',
  'verify.resending': 'Resending...',
  'verify.resend_success': 'Verification email sent.',
  'verify.resend_failed': 'Failed to resend. Please try again.',
  'verify.success_title': 'Email verified',
  'verify.success_desc': 'Your email has been verified. You can now log in.',
  'verify.failed_title': 'Verification failed',
  'verify.failed_desc': 'This verification link is invalid or expired.',
  'verify.missing_title': 'Missing link',
  'verify.missing_desc': 'No verification token was found.',
  'verify.back_login': 'Back to login',

  // About
  'about.hero_title_line1': 'Empowering Global',
  'about.hero_title_accent': 'Fluency',
  'about.hero_image_alt': 'Students community',
  'about.campus_title_prefix': 'A World-Class',
  'about.campus_title_accent': 'Facility',
  'dashboard.welcome': 'Welcome back,',
  'dashboard.overview': "Here's your learning progress overview",
  'dashboard.current_level': 'Current Level',
  'dashboard.level_label': 'Level',
  'dashboard.next_label': 'Next',
  'dashboard.intermediate': 'Intermediate',
  'dashboard.attendance': 'Attendance',
  'dashboard.classes': 'classes',
  'dashboard.next_class': 'Next Class',
  'dashboard.dont_miss': "Don't miss it!",
  'dashboard.upcoming_classes': 'Upcoming Classes',
  'dashboard.upcoming_classes_subtitle': 'Your next approved sessions',
  'dashboard.no_upcoming_classes': 'No upcoming classes yet.',
  'dashboard.my_courses': 'My Courses',
  'dashboard.payments': 'Payments',
  'dashboard.notifications': 'Notifications',
  'dashboard.no_notifications': 'No notifications yet.',
  'dashboard.explore_title': 'Get started by exploring our courses',
  'dashboard.explore_subtitle': 'Browse available courses and enroll to unlock your next level.',
  'dashboard.explore_action': 'Explore Courses',
  'dashboard.no_courses_title': 'No courses enrolled yet',
  'dashboard.no_courses_subtitle': 'Browse available courses and choose the right one for you.',
  'dashboard.description': 'Description',
  'dashboard.date': 'Date',
  'dashboard.amount': 'Amount',
  'dashboard.status': 'Status',
  'dashboard.payment_method': 'Payment Method',
  'dashboard.reference': 'Reference',
  'dashboard.invoice': 'Invoice',
  'dashboard.no_payments': 'No invoices or payments yet.',
  'teacher.welcome': 'Welcome,',
  'teacher.overview': 'Manage your classes and track student attendance',
  'teacher.today_classes': 'My Classes',
  'teacher.total_groups': 'Total Groups',
  'teacher.hours_month': 'Hours This Month',
  'teacher.classes_month': 'Classes This Month',
  'teacher.schedule': 'My Classes',
  'teacher.my_classes': 'My Classes',
  'teacher.schedule_requests': 'Schedule Requests',
  'teacher.schedule_type': 'Schedule Type',
  'teacher.weekly_schedule': 'Weekly Schedule',
  'teacher.flexible_schedule': 'Flexible Schedule',
  'teacher.attendance': 'Attendance',
  'teacher.hours': 'Hours Overview',
  'teacher.time': 'Time',
  'teacher.course': 'Course',
  'teacher.group': 'Group',
  'teacher.room': 'Room',
  'teacher.students': 'Students',
  'teacher.present': 'Present',
  'teacher.student': 'Student',
  'teacher.level': 'Level',
  'teacher.att_percent': 'Attendance %',
  'teacher.save': 'Save',
  'teacher.monthly_hours': 'Monthly Hours Breakdown',
  'teacher.total_month': 'Total This Month',
  'teacher.duration_hours': 'Session duration (hours)',
  'teacher.salary_period': 'Select a period to extract the salary slip',
  'teacher.date_from': 'From',
  'teacher.date_to': 'To',
  'teacher.generate_salary_slip': 'Update slip',
  'teacher.print_slip': 'Print slip',
  'teacher.total_hours': 'Total Hours',
  'teacher.total_sessions': 'Total Sessions',
  'teacher.hourly_rate': 'Hourly Rate',
  'teacher.salary_due': 'Salary Due',
  'teacher.allowance': 'Transportation allowance',
  'teacher.session_history': 'Session History',
  'teacher.no_sessions': 'No confirmed sessions in this period',
  'teacher.explore_title': 'No schedule or groups assigned yet',
  'teacher.explore_subtitle': 'You can start by reviewing the available courses.',
  'teacher.explore_action': 'Explore Courses',
  'teacher.no_schedule': 'No schedule available yet',
  'teacher.no_groups_title': 'No groups assigned yet',
  'teacher.no_groups_subtitle': 'Groups will appear here once they are assigned to you.',
  'teacher.sessions': 'Sessions',
  'teacher.notifications_on': 'Notifications On',
  'teacher.enable_notifications': 'Enable Notifications',
  'teacher.class_type': 'Class Type',
  'teacher.class_type_group': 'Group Class',
  'teacher.class_type_mini_group': 'Mini Group',
  'teacher.class_type_vip': 'VIP Private Class (One-to-One)',
  'teacher.session_type': 'Session Type',
  'teacher.days': 'Days',
  'teacher.start_after': 'Start After',
  'teacher.mode': 'Mode',
  'teacher.progress': 'Progress',
  'teacher.total': 'Total',
  'teacher.completed': 'Completed',
  'teacher.remaining': 'Remaining',
  'teacher.type': 'Type',
  'teacher.action': 'Action',
  'teacher.actions': 'Actions',
  'teacher.class_plan': 'Class Plan',
  'teacher.package': 'Package',
  'teacher.lesson_plan': 'Lesson plan',
  'teacher.topics_taught': 'Topics taught',
  'teacher.links': 'Links',
  'teacher.materials_notes': 'Materials notes',
  'teacher.upload_files': 'Upload files',
  'teacher.save_class_plan': 'Save Class Plan',
  'teacher.delete_attachment': 'Delete',
  'teacher.remove_file': 'Remove',
  'teacher.sessions_per_week': 'Sessions/Week',
  'teacher.group_approval': 'Group Approval',
  'teacher.accept': 'Accept',
  'teacher.request_change': 'Request Change',
  'teacher.no_action_needed': 'No action needed',
  'teacher.no_schedule_requests': 'No schedule requests yet.',
  'teacher.attendance_status': 'Attendance Status',
  'teacher.current_value': 'Current Value',
  'teacher.absent': 'Absent',
  'teacher.late': 'Late',
  'teacher.no_attendance_sessions': 'No generated sessions available for attendance.',
  'teacher.attendance_sessions_hint': 'Attendance is recorded against scheduled sessions after teacher approval.',
  'teacher.no_students_linked_session': 'No students are linked to this session.',
  'teacher.applied_rates': 'Applied rates',
  'teacher.no_completed_sessions': 'No completed sessions',
  'teacher.sessions_lower': 'sessions',
  'teacher.rate': 'Rate',
  'teacher.teaching': 'Teaching',
  'teacher.transportation': 'Transportation',
  'teacher.title': 'Title',
  'teacher.message': 'Message',
  'teacher.clear': 'Clear',
  'teacher.no_notifications': 'No notifications yet.',
  'teacher.notification_cleared': 'Notification cleared.',
  'teacher.no_generated_sessions_period': 'No generated sessions in this period.',
  'teacher.in_office': 'In Office',
  'teacher.loading_class_details': 'Loading class details...',
  'teacher.class_details_load_failed': 'Could not load class details.',
  'teacher.schedule_requests_load_failed': 'Could not load schedule requests. Please refresh.',
  'teacher.schedule_accepted': 'Schedule accepted.',
  'teacher.refresh_after_accept_failed': 'Schedule accepted, but the dashboard could not refresh automatically. Please refresh the page.',
  'teacher.schedule_change_prompt': 'What changes do you need in this schedule?',
  'teacher.change_request_sent': 'Change request sent to admin.',
  'teacher.class_plan_saved': 'Class plan saved.',
  'teacher.attachment_deleted': 'Attachment deleted.',
  'teacher.desktop_notifications_enabled': 'Desktop notifications enabled.',
  'teacher.browser_notifications_blocked': 'Browser notifications are blocked. Please allow them in browser settings.',
  'teacher.browser_notifications_unsupported': 'This browser does not support desktop notifications.',
  'teacher.package_completed': 'Package Completed',
  'teacher.progress_completed': 'Completed',
  'teacher.progress_remaining': 'Remaining',
  'teacher.state_scheduled': 'Scheduled',
  'teacher.state_in_progress': 'In Progress',
  'teacher.state_complete': 'Completed',
  'teacher.state_postponed': 'Postponed',
  'teacher.state_holiday': 'Holiday',
  'teacher.state_cancelled': 'Cancelled',
  'teacher.class_plan_submitted': 'Submitted',
  'teacher.class_plan_missing': 'Missing',
  'teacher.status_pending_teacher': 'Pending Teacher',
  'teacher.status_change_requested': 'Change Requested',
  'teacher.status_accepted': 'Accepted',
  'teacher.status_rejected': 'Rejected',

  // Social
  'social.kicker': 'FOLLOW US',
  'social.title': 'Latest From Our Social Media',
  'packages.english_title': 'English Packages',
  'packages.arabic_title': 'Arabic Packages',
  'packages.other_title': 'Other Language Packages',

  // Preferences
  'pref.title': 'Tell Us Your Preferences',
  'pref.subtitle': 'Help us recommend the best course for you.',
  'pref.contact_method': 'Preferred Contact Method',
  'pref.phone_call': 'Phone Call',
  'pref.course_format': 'Course Format',
  'pref.private': 'Private',
  'pref.group': 'Group',
  'pref.mini_group': 'Mini Group',
  'pref.language': 'Language',
  'pref.select_language': 'Select language',
  'pref.course_type': 'Course Type',
  'pref.select_type': 'Select course type',
  'pref.heard_from': 'How did you hear about us?',
  'pref.select_source': 'Select source',
  'pref.src_website': 'Website',
  'pref.src_email': 'Email',
  'pref.src_google': 'Google Search',
  'pref.src_referral': 'Referral',
  'pref.src_other': 'Other',
  'pref.notes': 'Additional Notes',
  'pref.notes_placeholder': 'Any specific requirements or questions...',

  'footer.courses': 'Our Courses',
  'footer.quick_links': 'Quick Links',
  'footer.contact': 'Contact Us',
  'footer.brand_description': 'Empowering global learners with world-class English education in the heart of Dubai.',
  'footer.rights': 'All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms & Conditions',
  'lang.switch_to_ar': 'العربية',
  'lang.switch_to_en': 'English',
  'lang.short_ar': 'ع',
  'lang.short_en': 'EN',
  'theme.switch_to_light': 'Light Mode',
  'theme.switch_to_dark': 'Dark Mode',

  // UI
  'ui.breadcrumb': 'Breadcrumb',
  'ui.more': 'More',
  'ui.carousel': 'Carousel',
  'ui.slide': 'Slide',
  'ui.prev_slide': 'Previous slide',
  'ui.next_slide': 'Next slide',
  'ui.close': 'Close',
  'ui.pagination': 'Pagination',
  'ui.prev_page': 'Go to previous page',
  'ui.next_page': 'Go to next page',
  'ui.previous': 'Previous',
  'ui.next': 'Next',
  'ui.more_pages': 'More pages',
};
